import { useEffect } from "react";

export function useScrollLock(active: boolean) {
    useEffect(() => {
        if (!active) return;

        // Measure before touching anything so we get the real scrollbar width
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        const prevOverflow = document.body.style.overflow;
        const prevPaddingRight = document.body.style.paddingRight;

        document.body.style.paddingRight = scrollbarWidth > 0 ? `${scrollbarWidth}px` : "";
        document.body.style.overflow = "hidden";

        return () => {
            document.body.style.overflow = prevOverflow;
            document.body.style.paddingRight = prevPaddingRight;
        };
    }, [active]);
}
